import { Model } from 'pinia-orm';

export default class Channel extends Model {
  static entity = 'channels';

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(''),
      username: this.attr(''),
      avatarUrl: this.attr(''),
      verified: this.attr(false),
      // Member's PoolShare earn rate (%) for buying from this channel. Read-only,
      // derived backend-side; nullable (null ⇒ no active program ⇒ hide the badge).
      // See ../backend ChannelSchema.php → Number::make('poolShareRate').
      poolShareRate: this.attr(null),
    };
  }
}
